import axios from 'axios';
import { Button, Input, Page, Text, message } from 'components';
import { AuthContext } from 'contexts';
import React from 'react';
import styled from 'styled-components';

const InvalidateMobileTokensPage = () => {
  const { auth } = React.useContext(AuthContext);
  const [isLoading, setIsLoading] = React.useState(false);
  const [email, setEmail] = React.useState(auth.email || '');

  const fire = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const trimmedEmail = email.trim();
      if (!trimmedEmail) return;
      setIsLoading(true);
      const { data } = await axios.delete<{ accessTokens: string[] }>(
        '/oauth/invalidate_token_qa',
        { data: { username: trimmedEmail } },
      );
      if (data.accessTokens) {
        const { accessTokens } = data;
        message.success(
          `Deleted ${accessTokens.length} token${
            accessTokens.length === 1 ? '' : 's'
          }`,
        );
      }
    } catch (error) {
      message.error(error?.toString(), 8);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Page type="filled" title="Invalidate Mobile Tokens QA Page">
      <Layout>
        <Text>
          This will revoke any mobile access/refresh tokens associated with the
          selected user
        </Text>
        <Text>
          Note that this is equivalent to waiting for the tokens to expire
          naturally which normally takes a long time. After revoking the tokens,
          the mobile app should redirect any device logged in as that user to
          the login page.
        </Text>
        <form onSubmit={fire}>
          <StyledInput
            addonAfter={
              <Button
                disabled={isLoading || !email}
                loading={isLoading}
                htmlType="submit"
              >
                Revoke
              </Button>
            }
            defaultValue={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="User email"
          />
        </form>
      </Layout>
    </Page>
  );
};

export default InvalidateMobileTokensPage;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding: 20px;
  background: white;
`;

const StyledInput = styled(Input)`
  width: 500px;
`;
